import React from "react";
import { MailIcon } from "lucide-react";
import { Container } from "./ui";
export function SiteFooter() {
  return <footer className="border-t border-line bg-cream pb-28 pt-10 text-center" data-id="element-179" data-mp="3r9at3qays44h">
      <Container data-id="element-180" data-mp="3mgrcekgzcsvg">
        <a href="mailto:support@stockdigital.shop" className="inline-flex items-center gap-2 text-lg font-semibold text-petrol underline-offset-4 hover:underline" data-id="element-181" data-mp="3mg85rzws5qwq">
          <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-182" data-mp="3dhw492udl8pi" />
          support@stockdigital.shop
        </a>
        <p className="mt-2 text-sm text-muted" data-id="element-183" data-mp="38gyr54o834uv">We reply in under 24 hours.</p>
      </Container>
    </footer>;
}